import { useIntl } from 'react-intl'
import { loyaltyUnitMessages } from 'constants/config/i18nMessages'

interface Props {
  points: number
  abbreviated?: boolean
}

/**
 * Formats a loyalty bonus points count with the correct plural unit label.
 *
 * @example
 * <FormatLoyaltyBonusPoints points={5} />               // "5 bonus points"
 * <FormatLoyaltyBonusPoints points={1} />               // "1 bonus point"
 * <FormatLoyaltyBonusPoints points={5} abbreviated />   // "5 bonus pts"
 */
function FormatLoyaltyBonusPoints({ points, abbreviated }: Props) {
  const intl = useIntl()
  const message = abbreviated ? loyaltyUnitMessages.bonusPointsAbbreviationCount : loyaltyUnitMessages.bonusPointsCount
  return <>{intl.formatMessage(message, { count: points })}</>
}

export default FormatLoyaltyBonusPoints
